import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import axiosInstance from '../axiosConfig';

const SchoolProfilesOverview = () => {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    const fetchSchoolProfiles = async () => {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.get('/admin/schools', {
        headers: {
          Authorization: `${token}`,
        },
      });
      setSchools(response.data);
      console.log("Schools: ", response.data);
    };
    fetchSchoolProfiles();
  }, []);

  return (
    <Box sx={{ ml: '1rem', mr: '1rem'}}>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Telefonnummer</th>
            <th>Benutzer</th>
          </tr>
        </thead>
        <tbody>
          {schools.map((school) => (
            <tr key={school._id}>
              <td>{school.name}</td>
              <td>{school.contactEmail}</td>
              <td>{school.contactPhone}</td>
              <td>
                {school.users && school.users.length > 0
                  ? school.users.map((user) => user.name).join(', ')
                  : 'Keine Benutzer zugeordnet'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default SchoolProfilesOverview;
